(function () {
  'use strict';
  angular
    .module('module.products-grid', [])

    /* @ngInject */
    .directive('productsGrid', ["WindowEventsService", "productsGridService", function (WindowEventsService, productsGridService) {
      return {
        restrict: 'A',
        link: function (scope, element) {
          if (!element.children('.row').length) return;

          var tmpId = element.attr('id') || 'pg_' + productsGridService.getId();
          element.attr('id', tmpId);

          setTimeout(function () {
            WindowEventsService.listen(true, 'resize', resize, 500);
          });

          scope.$on('$destroy', function () {
            WindowEventsService.listen(false, 'resize', resize);
          });

          resize();

          // Functions

          function resize() {
            setTimeout(function () {
              productsGridService.resizeGrid(tmpId, scope.device.size, false);
            });
          }
        }
      };
    }])

    /* @ngInject */
    .service('productsGridService', function () {
      var tmpId = 0;
      this.getId = function () {
        return tmpId++;
      };
      this.resizeGrid = function (elemId, size, lazy) {
        var $elem = $('#' + elemId),
          $divs = $elem.children('.row').children('.grid:visible');

        if ($divs.length < 2) return;

        if (!lazy) {
          $divs.children().addClass('init').find('.content').children().height('');
        }

        var col = $divs.eq(0).attr('class').split('col-' + size + '-')[1];

        if (!col) {
          return;
        }

        var nb = 12 / col.split(' ')[0];
        if (nb === 1) return;

        var i, j, targ, len = $divs.find('.product-item').length;
        for (i = 0; i < len; i += nb) {
          targ = $divs.slice(i, i + nb).children('.init').removeClass('init').find('.content');

          var n = targ.eq(0).children().length;
          for (j = 0; j < n; j++) {
            targ.find('.' + $(targ.eq(0).children().eq(j)).attr('class').split(' ')[0]).equalHeights();
          }
        }
      };
    });
})();
